import services from "../../services/service";
let service = new services();

export default {
    name: 'DashboardFooter',
    data() {
        return {
            this_year: service.thisYear,
        }
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/components/Dashboard-Footer/script.js